<template>
    <div>Capture</div>
</template>

<script>
export default {
    created(){
        //alert('capture created');
    },
    mounted:function(){
         this.$store.state.heading="Capture";
    }
}
</script>